
// @ts-nocheck


export const localeCodes =  [
  "en",
  "vi"
]

export const localeLoaders = {
  "en": [{ key: "../app/assets/locale/en.json", load: () => import("../app/assets/locale/en.json" /* webpackChunkName: "locale__home_jenkins_agent_workspace_nhegui_offcial_website_ui_master_app_assets_locale_en_json" */), cache: true }],
  "vi": [{ key: "../app/assets/locale/vi.json", load: () => import("../app/assets/locale/vi.json" /* webpackChunkName: "locale__home_jenkins_agent_workspace_nhegui_offcial_website_ui_master_app_assets_locale_vi_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "_home_jenkins_agent_workspace_nhegui_offcial_website_ui_master_i18n_config_ts_bffaebcb" */),
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "_home_jenkins_agent_workspace_nhegui_offcial_website_ui_master_i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": true,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "name": "English",
      "dir": "ltr",
      "files": [
        "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/assets/locale/en.json"
      ]
    },
    {
      "code": "vi",
      "language": "vi-VN",
      "name": "Tiếng Việt",
      "dir": "ltr",
      "files": [
        "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/assets/locale/vi.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "assets/locale",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "nuxt-template-language",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "http://localhost:3000",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "name": "English",
    "dir": "ltr",
    "files": [
      {
        "path": "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/assets/locale/en.json",
        "cache": true
      }
    ]
  },
  {
    "code": "vi",
    "language": "vi-VN",
    "name": "Tiếng Việt",
    "dir": "ltr",
    "files": [
      {
        "path": "/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/assets/locale/vi.json",
        "cache": true
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
